module.exports = __webpack_public_path__ + "static/media/badCoShirt.f7fbbcb1.jpg";